import { AccessManagementClinicUserGetResponse } from '@surglogs-app/network'

export const getJoinedAssignedRoles = (
  clinicRoles: AccessManagementClinicUserGetResponse['clinic_roles'],
) =>
  clinicRoles
    ?.filter((r) => r.is_assigned)
    .map((role) => role.name)
    .join(', ')
